import { render, staticRenderFns } from "./ChatColumn.vue?vue&type=template&id=77add2c9&lang=pug"
import script from "./ChatColumn.vue?vue&type=script&lang=ts"
export * from "./ChatColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports